import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'ngxui-taskbar-tabs-left',
  templateUrl: './taskbar-tabs-left.component.html',
  styleUrls: ['./taskbar-tabs-left.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class TaskbarTabsLeftComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
